import { useEffect, useState } from "react";
import { Message } from "../../../models/Message";
import { getFileAccessReferences } from "../../../utils/fileAccessURL";
import { useFileAccessURL } from "../../../hooks/useFileAccessURL";
import { StickerView } from "./styles";
import { MessageTextContent } from "../TextContent";

export interface StickerProps {
  message: Message;
};

export const Sticker = ({ message }: StickerProps ) => {
  const references = getFileAccessReferences( message.fileMetadata, "inline", "image" );
  const primaryURL = useFileAccessURL({
    mode: "inline",
    reference: references[ 0 ],
  });
  const fallbackURL = useFileAccessURL({
    mode: "inline",
    reference: references[ 1 ],
    enabled: Boolean( references[ 1 ]),
  });
  const [ stickerURL, setStickerURL ] = useState( primaryURL );

  useEffect(() => {
    setStickerURL( primaryURL );
  }, [ primaryURL ]);

  return (
    <StickerView>
      <div className="sticker-frame">
        {
          stickerURL ? (
            <img
              src={ stickerURL }
              alt={ message.fileMetadata?.fileName ?? "Figurinha" }
              onError={() => {
                if( fallbackURL && stickerURL !== fallbackURL ) setStickerURL( fallbackURL );
              }}
            />
          ) : <span>Figurinha</span>
        }
      </div>

      {
        message.content !== "" && (
          <MessageTextContent content={ message.content } />
        )
      }
    </StickerView>
  );
};
